module.exports = __webpack_public_path__ + "img/avatar.5097b024.png";